import React from 'react';
import CardItem from './CardItem/CardItem';
import classes from './ScoreboardHeader.module.css';

const ScoreboardHeader = ({ banner = {}, activeTabId, currentIds = {}, onCardClick, onCardHover, onCardLeave }) => {

  return (
    <div className={classes.statsHeader}>
      <div className={classes.statsContainer}>
        {banner?.items?.map((item, index) => (
          <CardItem
            key={item.id || index}
            item={item}
            currentIds={currentIds}
            activeTabId={activeTabId}
            onCardClick={onCardClick}
            onCardHover={onCardHover}
            onCardLeave={onCardLeave}
            number={item?.number}
          />
        ))}
      </div>
    </div>
  );
};

export default ScoreboardHeader;
